<div class="content">
  <div class="video-content">
    <video
      *ngIf="videoCapable"
      class="{{ !isSelf && isMobile ? '' : 'video-inverter' }}"
      #video
      autoplay
      playsinline
    ></video>
    <div *ngIf="videoCapable" class="action-buttons">
      <button
        (click)="onSnap()"
        type="button"
        mat-raised-button
        [disabled]="isLoading"
      >
        Tirar Foto <img src="assets/photo.svg" alt="photo" />
      </button>

      <button
        (click)="onCancel($event)"
        type="button"
        mat-stroked-button
        class="cancel-button"
        [disabled]="isLoading"
      >
        Cancelar <img src="assets/cancel.svg" alt="cancel" />
      </button>
    </div>
  </div>
  <div
    class="mask"
    [ngClass]="{ 'mask-document': !isSelf, 'mask-self': isSelf }"
  >
    <h1 class="selfie-text">Posicione o seu rosto ocupando o espaço abaixo:</h1>
    <h1 class="document-text">
      Posicione o documento ocupando o espaço abaixo:
    </h1>

    <svg class="mask-overlay">
      <defs>
        <mask id="hole" x="0" y="0" width="100%" height="100%">
          <rect width="100%" height="100%" fill="white" />
          <rect
            class="selfie-mobile"
            width="400"
            height="600"
            rx="200"
            x="50%"
            y="50%"
            transform="translate(-200,-300)"
          />
          <rect
            class="selfie-desktop"
            width="400"
            height="600"
            rx="200"
            x="50%"
            y="50%"
            transform="translate(-200,-300)"
          />
          <!-- <path 
          d="M420.9,77.3c107.5,0,137.3,89,141.5,122.5c4.3,33.5,12.9,131.5-6.8,186.7s-73.1,131.3-134.7,131.3s-115-76-134.7-131.3
          s-10.9-153.1-6.8-186.7S313.4,77.3,420.9,77.3z"/> -->
          <rect
            class="document-desktop"
            width="96%"
            height="96%"
            rx="16"
            x="2%"
            y="2%"
          />
          <rect
            class="document-mobile"
            width="96%"
            height="96%"
            rx="16"
            x="2%"
            y="2%"
          />
        </mask>
      </defs>

      <rect
        class="overlay"
        width="100%"
        height="100%"
        id="donut"
        mask="url(#hole)"
        opacity="0.85"
      />
    </svg>
  </div>
  <div *ngIf="!videoCapable">Acesso negado</div>
</div>

<canvas #canvas></canvas>
